import React from "react";
import PropTypes from "prop-types";

import FormGroup from "@mui/material/FormGroup";
import LookUserPhoneInput from "../../user/lookUserPhoneInput";
import LookUserInput from "../../user/lookUserInput";

const LeadCapturePopupTwoFA = (props) => {

  const {inputsValidated} = props;

  return (
    <FormGroup className="grohe-lead__form">
      <div className="gc-form__center">
        <div className="gc-form__inputs-block">
          <LookUserPhoneInput property={"phoneNumber"} inputsValidated={inputsValidated} />
        </div>
        <div className="gc-form__inputs-block gc-form__inputs-block--hidden">
          <LookUserInput property={"hidden"} inputsValidated={true} /> {/*this input is needed here for Material UI to add its styles! */}
        </div>
      </div>
    </FormGroup>
  )
};

LeadCapturePopupTwoFA.propTypes = {
  inputsValidated: PropTypes.bool.isRequired,
}

export default LeadCapturePopupTwoFA
